/**
 * Human-readable package name for enrollment agreement templates.
 *
 * field_enrollment_package_name is an entity reference to a package, and it
 * reaches the templates in several shapes:
 *  - saved entity via the ECK REST wrapper: collapsed package object { id, title, type: 'package', ... }
 *  - the enrollment form / preview mock: "Package Title (12345)" text, a bare id, or [{ value }]
 * Anything that is only an id renders as '' rather than leaking the number onto the agreement.
 */
export function agreementPackageName(raw: any): string {
  if (!raw) return '';
  if (Array.isArray(raw)) {
    return agreementPackageName(raw[0]?.value ?? raw[0]);
  }
  if (typeof raw === 'object') {
    if (typeof raw.title === 'string' && raw.title) return raw.title;
    if ('value' in raw) return agreementPackageName(raw.value);
    return '';
  }
  const text = String(raw).trim();
  if (!text || /^\d+$/.test(text)) return '';
  // Strip the trailing "(id)" the autocomplete appends.
  return text.replace(/\s*\(\d+\)\s*$/, '');
}
